import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map, tap, } from 'rxjs/operators';
import { FeedbackService } from 'src/app/shared/feedback.service';
import { NoteService } from '../../notes/note.service';
import * as NotesActions from './note.actions';

@Injectable()
export class NoteEffects {

  notesList$ = createEffect(() =>
    this.actions.pipe(
      ofType(NotesActions.fetchNotes),
      exhaustMap(() =>
        this.noteService.getItems().pipe(
          map((response) =>
            NotesActions.getNotesSuccess({
              notes: response,
            })
          ),
          catchError((err) => of(NotesActions.getNotesError({ error: err })))
        )
      )
    )
  );

  fetchNote$ = createEffect(() =>
    this.actions.pipe(
      ofType(NotesActions.fetchNotesDetail),
      exhaustMap(({ noteId }) =>
        this.noteService.getOne(noteId).pipe(
          map((note) => NotesActions.notesDetailLoaded({ note })),
          catchError((err) => of(NotesActions.notesDetailLoadError({ error: err })))
        )
      )
    )
  );

  addNote$ = createEffect(() =>
    this.actions.pipe(
      ofType(NotesActions.noteSubmitted),
      exhaustMap((action) =>
        this.noteService.addItem(action.note).pipe(
          map((response) =>
            NotesActions.noteSubmitOk({
              data: response,
            })
          ),
          catchError((err) => of(NotesActions.noteSubmitError({ error: err })))
        )
      )
    )
  );

  addNoteOKFeedback$ = createEffect(() =>
    this.actions.pipe(
      ofType(NotesActions.noteSubmitOk),
      tap(() => {
        this.feedbackService.success('Created!');
        this.router.navigate(['/notes']);
      }),
      map(() => NotesActions.fetchNotes())
    )
  );

  editNote$ = createEffect(() =>
    this.actions.pipe(
      ofType(NotesActions.editNote),
      exhaustMap((action) =>
        this.noteService.updateItem(action.note.id, action.note).pipe(
          map((response) =>
            NotesActions.editNoteOk({
              data: response,
            })
          ),
          catchError((err) => of(NotesActions.editNoteError({ error: err })))
        )
      )
    )
  );

  editNoteOKFeedback$ = createEffect(() =>
    this.actions.pipe(
      ofType(NotesActions.editNoteOk),
      tap(() => {
        this.feedbackService.success('Saved!');
        this.router.navigate(['/notes']);
      }),
      map(() => NotesActions.fetchNotes())
    ),
  );

  deleteNote$ = createEffect(() =>
    this.actions.pipe(
      ofType(NotesActions.deleteNoteRequest),
      exhaustMap((action) =>
        this.noteService.deleteItem(action.id).pipe(
          map((response) =>
            NotesActions.deleteNoteSucess({
              result: response,
            })
          ),
          catchError((err) => of(NotesActions.deleteNoteError({ error: err })))
        )
      )
    )
  );

  deleteNoteOKFeedback$ = createEffect(() =>
    this.actions.pipe(
      ofType(NotesActions.deleteNoteSucess),
      tap(() => {
        this.feedbackService.success('Deleted!');
        this.router.navigate(['/notes']);
      }),
      map(() => NotesActions.fetchNotes())
    )
  );

  deleteNoteErrorFeedback$ = createEffect(
    () =>
      this.actions.pipe(
        ofType(NotesActions.deleteNoteError),
        tap(() => {
          this.feedbackService.success('Something went wrong!');
        })
      ),
    { dispatch: false }
  );


  constructor(
    private actions: Actions,
    private noteService: NoteService,
    private feedbackService: FeedbackService,
    private router: Router
  ) {
  }
}
